import { commonRules, RuleType } from 'helpers/form-validations';

export const validationRules = {
  model: [commonRules.required],
  quantity: [
    commonRules.required,
    { type: RuleType.Min, value: 1, message: 'the quantity should be at least 1' },
  ]
};
